<template>
  <div class="d-flex flex-column row-gap-4">
    <div class="d-flex flex-column row-gap-2">
      <h1>{{$t('project.bibles.BiblesHeader.biblesTitle')}}</h1>
      <p class="text--small">
        {{$t('project.bibles.BiblesHeader.biblesSubTitle')}}
      </p>
    </div>
    <BiblesButtonBar 
      :disabled="disabled"
      :sort="sort"
      @generate-bible="onGenerateBible"
      @input="onSort"
    />
  </div>
</template>

<script lang="ts">
import BiblesButtonBar from '@/project/bibles/BiblesButtonBar.vue'

export default {
  name: 'BiblesHeader',
  components: {
    BiblesButtonBar,
  },
  props: {
    disabled: {
      type: Boolean,
    },
    sort: {
      type: String,
      required: true,
    },
  },
  methods: {
    onGenerateBible() {
      this.$emit('generate-bible', true);
    },
    onSort(value: string) {
      this.$emit('input', value);
    },
  },
}
</script>
